import React, { useState, useEffect, useCallback, useRef } from 'react';
import Navbar from '../components/Navbar';
import AdCard from '../components/AdCard';
import api from '../api/axios';

const cacheKey = (tab, country, period, orderBy, metaKeyword, metaStatus) =>
  `dashboard_cache_${tab}_${country}_${period}_${orderBy}_${metaKeyword}_${metaStatus}`;
// key ke andar hi status ko orderBy ke saath jod dete hain jab tab tiktok ho (cacheKey signature same rakhne ke liye)

function TikTokSVG({ active }) {
  return (
    <svg width="14" height="16" viewBox="0 0 24 24" fill={active ? '#fff' : '#666'}>
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.17 8.17 0 004.78 1.52V6.77a4.85 4.85 0 01-1.01-.08z"/>
    </svg>
  );
}

function MetaSVG({ active }) {
  return (
    <svg width="26" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="mg" x1="0" y1="8" x2="16" y2="8" gradientUnits="userSpaceOnUse">
          <stop offset="0%"   stopColor={active ? "#0082FB" : "#555"} />
          <stop offset="100%" stopColor={active ? "#0040C4" : "#444"} />
        </linearGradient>
      </defs>
      <path fillRule="evenodd" fill="url(#mg)" d="M8.217 5.243C9.145 3.988 10.171 3 11.483 3C13.96 3 16 6.153 16.001 9.907c0 2.29-.986 3.725-2.757 3.725-1.543 0-2.395-.866-3.924-3.424l-.667-1.123-.118-.197a55 55 0 0 0-.53-.877l-1.178 2.08c-1.673 2.925-2.615 3.541-3.923 3.541C1.086 13.632 0 12.217 0 9.973C0 6.388 1.995 3 4.598 3q.477-.001.924.122c.31.086.611.22.913.407c.577.359 1.154.915 1.782 1.714m1.516 2.224q-.378-.615-.727-1.133L9 6.326c.845-1.305 1.543-1.954 2.372-1.954c1.723 0 3.102 2.537 3.102 5.653c0 1.188-.39 1.877-1.195 1.877-.773 0-1.142-.51-2.61-2.87zM4.846 4.756c.725.1 1.385.634 2.34 2.001A212 212 0 0 0 5.551 9.3c-1.357 2.126-1.826 2.603-2.581 2.603-.777 0-1.24-.682-1.24-1.9c0-2.602 1.298-5.264 2.846-5.264q.137 0 .27.018"/>
    </svg>
  );
}

const MAIN_TABS = [
  {
    id: 'tiktok',
    label: 'TikTok',
    logo: (on) => <TikTokSVG active={on} />,
    activeBg:     'rgba(255,255,255,.05)',
    activeBorder: 'rgba(255,255,255,.25)',
    activeColor:  '#fff',
    activeShadow: 'none',
  },
  {
    id: 'meta',
    label: 'Meta',
    logo: (on) => <MetaSVG active={on} />,
    activeBg:     'rgba(24,119,242,.08)',
    activeBorder: '#1877F2',
    activeColor:  '#5aabff',
    activeShadow: '0 0 12px rgba(24,119,242,.18)',
  },
];

const HIGHLIGHT_LABELS = { weekly: 'Week ⚡', monthly: 'Month 💎' };

function HighlightPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [tick, setTick] = useState('weekly');
  const ref = useRef(null);

  // idle rotation (None state) — purely visual, filter stays off
  useEffect(() => {
    if (value !== 'none') return;
    const id = setInterval(() => setTick(t => (t === 'weekly' ? 'monthly' : 'weekly')), 2500);
    return () => clearInterval(id);
  }, [value]);

  useEffect(() => {
    const onDocClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  const closedLabel = value === 'none' ? HIGHLIGHT_LABELS[tick] : HIGHLIGHT_LABELS[value];

  return (
    <div ref={ref} style={{ position: 'relative', width: '100%' }}>
      <div
        className="hl-pill"
        onClick={() => setOpen(o => !o)}
        style={{
          height: '38px', background: '#161625',
          border: '1px solid rgba(255,255,255,.08)',
          borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0 .9rem', cursor: 'pointer', overflow: 'hidden', boxSizing: 'border-box',
        }}>
        <div style={{ position: 'relative', flex: 1, height: '17px', overflow: 'hidden' }}>
          <span key={value === 'none' ? tick : value} className="hl-item"
            style={{ position: 'absolute', left: 0, top: 0, fontSize: '.85rem', fontWeight: 400, color: '#f0f0f8', whiteSpace: 'nowrap' }}>
            {closedLabel}
          </span>
        </div>
        <span style={{ fontSize: '.65rem', color: '#8888aa', marginLeft: '6px', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .25s ease' }}>▾</span>
      </div>
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', left: 0, width: '100%',
          background: '#161625', border: '1px solid rgba(255,255,255,.12)', borderRadius: '8px',
          overflow: 'hidden', zIndex: 10, boxShadow: '0 8px 24px rgba(0,0,0,.4)',
        }}>
          {['weekly', 'monthly'].map(opt => (
            <div key={opt} className="hl-menu-item" onClick={() => { onChange(value === opt ? 'none' : opt); setOpen(false); }}
              style={{
                padding: '.6rem .9rem', fontSize: '.85rem', fontWeight: 400, cursor: 'pointer',
                height: '38px', display: 'flex', alignItems: 'center', boxSizing: 'border-box',
                color: value === opt ? '#f0f0f8' : '#ccc',
                background: value === opt ? 'rgba(139,107,255,.15)' : 'transparent',
              }}>
              {HIGHLIGHT_LABELS[opt]}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function Dashboard() {
  const [ads, setAds]           = useState([]);
  const [loading, setLoading]   = useState(true);
  const [tab, setTab]           = useState(() => sessionStorage.getItem('dash_tab') || 'tiktok');
  // Pehle default '7' (7D) tha, ab default 'All' hona chahiye. sessionStorage
  // mein purani sessions se '7' already saved ho sakta hai (kyunki wahi default
  // tha, koi real user-choice nahi) — isliye stored '7' ko bhi "unset" treat
  // karke 'All' pe fallback karte hain.
  const initPeriod = (key) => {
    const stored = sessionStorage.getItem(key);
    return stored && stored !== '7' ? stored : '';
  };
  const [period, setPeriod]     = useState(() => initPeriod('dash_period'));
  const [orderBy, setOrderBy]   = useState(() => sessionStorage.getItem('dash_orderBy') || 'like');
  const [tiktokStatus, setTiktokStatus] = useState(() => sessionStorage.getItem('dash_tiktokStatus') || 'ALL');
  const [tiktokCountry, setTiktokCountry] = useState(() => sessionStorage.getItem('dash_tiktokCountry') || 'ALL');
  const [metaKeyword, setMetaKeyword] = useState('product');
  const [metaStatus, setMetaStatus]   = useState('ACTIVE');
  const [metaCountry, setMetaCountry] = useState(() => sessionStorage.getItem('dash_metaCountry') || 'ALL');
  const [metaPeriod, setMetaPeriod]   = useState(() => initPeriod('dash_metaPeriod'));
  const [metaSortBy, setMetaSortBy]   = useState(() => sessionStorage.getItem('dash_metaSortBy') || 'trending');
  const [highlight, setHighlight]     = useState(() => sessionStorage.getItem('dash_highlight') || 'none'); // 'none' | 'weekly' | 'monthly'
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const [savedIds, setSavedIds] = useState(new Set());
  useEffect(() => {
    api.get('/ads/saved').then(res => {
      const ids = (res.data?.data || []).map(a => a.id);
      setSavedIds(new Set(ids));
    }).catch(() => {});
  }, []);

  const [userCredits, setUserCredits] = useState(null);
  useEffect(() => {
    api.get('/user/profile').then(res => {
      const u = res.data?.usage;
      if (u) setUserCredits({ remaining: u.creditsRemaining });
    }).catch(() => {});
  }, []);
  const LOCK_THRESHOLD = 20;
  const noCredits   = userCredits !== null && userCredits.remaining <= 0;
  const lockActive  = userCredits !== null && userCredits.remaining <= LOCK_THRESHOLD;

  const countries = ['US','DE','GB','FR','IT','ES','NL','PL','AT','BE','SE','NO','DK','FI'];
  const periods   = [{ v: '', l: 'All' },{ v: '7', l: '7D' },{ v: '30', l: '30D' },{ v: '90', l: '90D' },{ v: '180', l: '180D' },{ v: '365', l: '365D' }];
  const orders    = [{ v: 'impression', l: '👁 Impressions' },{ v: 'like', l: '❤️ Likes' },{ v: 'ctr', l: '📊 CTR' },{ v: 'cost', l: '💰 Ad Spend' }];

  const metaCountries = ['ALL', ...countries];
  const ordersMeta    = [{ v: 'trending', l: '🔥 Trending' },{ v: 'likes', l: '❤️ Likes' },{ v: 'ctr', l: '📊 CTR' },{ v: 'spend', l: '💰 Ad Spend' }];

  useEffect(() => { sessionStorage.setItem('dash_tab', tab); }, [tab]);
  useEffect(() => { sessionStorage.setItem('dash_period', period); }, [period]);
  useEffect(() => { sessionStorage.setItem('dash_orderBy', orderBy); }, [orderBy]);
  useEffect(() => { sessionStorage.setItem('dash_tiktokStatus', tiktokStatus); }, [tiktokStatus]);
  useEffect(() => { sessionStorage.setItem('dash_tiktokCountry', tiktokCountry); }, [tiktokCountry]);
  useEffect(() => { sessionStorage.setItem('dash_metaCountry', metaCountry); }, [metaCountry]);
  useEffect(() => { sessionStorage.setItem('dash_metaPeriod', metaPeriod); }, [metaPeriod]);
  useEffect(() => { sessionStorage.setItem('dash_metaSortBy', metaSortBy); }, [metaSortBy]);
  useEffect(() => { sessionStorage.setItem('dash_highlight', highlight); }, [highlight]);

  // ── Recommended (highlight) filter ─────────────────────────────────────────
  // Ye filter baaki sab (country/status) se ALAG hai: koi bhi country ho, active ya
  // inactive dono ho — sirf market mein sabse acha perform kar rahe ads dikhane hain
  // (high impressions/spend/ctr — is data ko backend "trending_score" mein combine
  // karke deta hai). Isliye highlight ON hone par country/status filters ignore
  // karke hamesha ALL bhejte hain, aur sort hamesha "trending" (performance) se hota hai.
  // Period: pehle WEEK (7 din) ke "naye" ads try karo — agar kaafi na milein to
  // automatically MONTH (30 din) tak expand kar do (fallback neeche fetchAds mein hai).
  const isRecommended = highlight !== 'none';

  const effCountry     = isRecommended ? 'ALL' : tiktokCountry;
  const effStatus      = isRecommended ? 'ALL' : tiktokStatus;
  const effPeriod      = isRecommended ? (highlight === 'monthly' ? '30' : '7') : period;
  const effOrderBy     = isRecommended ? 'trending' : orderBy;

  const effMetaCountry = isRecommended ? 'ALL' : metaCountry;
  const effMetaStatus  = isRecommended ? 'ALL' : metaStatus;
  const effMetaPeriod  = isRecommended ? (highlight === 'monthly' ? '30' : '7') : metaPeriod;
  const effMetaSortBy  = isRecommended ? 'trending' : metaSortBy;

  const [highlightExpanded, setHighlightExpanded] = useState(false); // true = week se month tak expand hua (backend ne bataya)

  const fetchAds = useCallback(async () => {
    const key = tab === 'meta'
      ? cacheKey(tab, effMetaCountry, effMetaPeriod, effMetaSortBy, metaKeyword, effMetaStatus)
      : cacheKey(tab, effCountry, effPeriod, effOrderBy, '', effStatus);
    const cached = sessionStorage.getItem(key);
    if (cached) {
      try { setAds(JSON.parse(cached)); setHighlightExpanded(false); setLoading(false); return; } catch {}
    }

    setLoading(true); setAds([]); setHighlightExpanded(false);
    try {
      if (tab === 'tiktok') {
        // ✅ recommended=true → backend khud country/status ignore karke, sirf top
        // performing (trending) ads deta hai, aur zaroorat pade to WEEK se MONTH
        // tak khud expand kar deta hai (single request — extra credit charge nahi)
        const res = await api.get('/ads/tiktok', { params: { country: effCountry, period: effPeriod, order: effOrderBy, activeStatus: effStatus, recommended: isRecommended, limit: 500 } });
        const d = res.data;
        // Backend returns: { success, data: { materials: [...] } }
        const raw = d?.data?.materials || d?.data?.list || d?.data?.ad_list ||
          (Array.isArray(d?.data) ? d.data : null) ||
          d?.materials || d?.list || [];
        const allAds = Array.isArray(raw) ? raw : [];

        const NON_OBJ = ['app_install','app_promotion','reach','brand_awareness','lead_generation','video_views','traffic','messages'];
        const NON_IND = ['music','concert','event','gaming','game','entertainment','news','media','political','religion','education','software','finance','insurance','real_estate','recruitment','ngo'];
        const NON_KW  = ['concert','tour','ticket','event','festival','live show','album','stream now','download app','install','sign up','apply now','vote','donate','webinar','seminar','course','slots','casino','betting','loan','insurance','mortgage'];

        const result = allAds.filter(ad => {
          const obj = (ad.objective_key||'').toLowerCase();
          const ind = (ad.industry_key||'').toLowerCase();
          const ttl = (ad.ad_title||ad.title||'').toLowerCase();
          if (NON_OBJ.some(o => obj.includes(o))) return false;
          if (NON_IND.some(i => ind.includes(i))) return false;
          if (NON_KW.some(k => ttl.includes(k))) return false;
          return true;
        });
        setAds(result);
        setHighlightExpanded(!!d?.expandedToMonth);
        sessionStorage.setItem(key, JSON.stringify(result));
        if (d?.creditsRemaining !== undefined) {
          setUserCredits(prev => ({ ...prev, remaining: d.creditsRemaining }));
          window.dispatchEvent(new Event('credits-updated'));
        }

      } else if (tab === 'meta') {
        const res = await api.get('/ads/meta', { params: { keyword: metaKeyword, country: effMetaCountry, activeStatus: effMetaStatus, period: effMetaPeriod, sortBy: effMetaSortBy, recommended: isRecommended, limit: 500 } });
        const raw = res.data?.data;
        const normalized = Array.isArray(raw) ? raw : [];
        // ✅ Duplicate remove — library_id se dedup
        const deduped = [...new Map(normalized.map(ad => [
          ad._raw?.library_id || ad.id || Math.random(), ad
        ])).values()];
        setAds(deduped);
        setHighlightExpanded(!!res.data?.expandedToMonth);
        sessionStorage.setItem(key, JSON.stringify(deduped));
        if (res.data?.creditsRemaining !== undefined) {
          setUserCredits(prev => ({ ...prev, remaining: res.data.creditsRemaining }));
          window.dispatchEvent(new Event('credits-updated'));
        }
      }
    } catch (err) {
      if (err.response?.status === 429 && err.response?.data?.upgrade) {
        setUserCredits(prev => ({ ...prev, remaining: 0 }));
      }
      console.error(err); setAds([]);
    }
    setLoading(false);
  }, [tab, effCountry, effPeriod, effOrderBy, effStatus, metaKeyword, effMetaStatus, effMetaCountry, effMetaPeriod, effMetaSortBy, isRecommended]);

  useEffect(() => {
    fetchAds();
  }, [fetchAds]);

  return (
    <div style={{ minHeight: '100vh', background: '#08080f' }}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes hlSlideUp { 0% { transform: translateY(100%); opacity: 0; } 100% { transform: translateY(0); opacity: 1; } }
        .hl-item { animation: hlSlideUp .45s cubic-bezier(.4,0,.2,1); }
        .hl-pill:hover { border-color: rgba(139,107,255,.4) !important; }
        .hl-menu-item:hover { background: rgba(255,255,255,.06) !important; }
        select:disabled { opacity: .5; cursor: not-allowed; }
        .filterBar select { border: 1px solid rgba(255,255,255,.08); transition: border-color .15s ease; }
        .filterBar select:focus { outline: none; border-color: #8b6bff !important; }
      `}</style>
      <Navbar />
      <div style={s.page}>

        <div style={s.hero}>
          <h1 style={s.h1}>Welcome back, <span style={{ color: '#8b6bff' }}>{user.name}</span> 👋</h1>
          <p style={s.sub}>🚀 Discover your next winning product</p>
        </div>

        {/* Lock Threshold Banner */}
        {lockActive && !noCredits && (
          <div style={{ ...s.noCreditBanner, background: 'rgba(251,191,36,.07)', borderColor: 'rgba(251,191,36,.25)', color: '#fbbf24' }}>
            <span>⚠️ Only {userCredits.remaining} credits left — only previously viewed ads will open now</span>
            <a href="/profile" style={{ ...s.upgradeLink, color: '#fbbf24' }}>Upgrade →</a>
          </div>
        )}

        {/* No Credits Banner */}
        {noCredits && (
          <div style={s.noCreditBanner}>
            <span>🔒 Credits exhausted — only viewed ads are accessible.</span>
            <a href="/profile" style={s.upgradeLink}>Upgrade →</a>
          </div>
        )}

        {/* TABS */}
        <div style={s.tabRow}>
          {MAIN_TABS.map(t => {
            const on = tab === t.id;
            return (
              <button key={t.id} onClick={() => setTab(t.id)}
                style={{
                  ...s.tab,
                  ...(on ? {
                    background:  t.activeBg,
                    border:      `1.5px solid ${t.activeBorder}`,
                    color:       t.activeColor,
                    boxShadow:   t.activeShadow,
                  } : {})
                }}>
                {t.logo(on)}
                <span>{t.label}</span>
              </button>
            );
          })}
        </div>

        {/* TIKTOK FILTERS */}
        {tab === 'tiktok' && (
          <div className="filterBar" style={s.filterBar}>
            <div style={s.fg}><label style={s.lbl}>🌍 COUNTRY</label>
              <select style={s.sel} value={tiktokCountry} onChange={e => { setTiktokCountry(e.target.value); if (isRecommended) setHighlight('none'); }}>
                {metaCountries.map(c => <option key={c} value={c}>{c === 'ALL' ? 'All Countries' : c}</option>)}
              </select>
            </div>
            <div style={s.fg}><label style={s.lbl}>📅 PERIOD</label>
              <select style={s.sel} value={period} onChange={e => { setPeriod(e.target.value); if (isRecommended) setHighlight('none'); }}>
                {periods.map(p => <option key={p.v} value={p.v}>{p.l}</option>)}
              </select>
            </div>
            <div style={s.fg}><label style={s.lbl}>📊 SORT BY</label>
              <select style={s.sel} value={orderBy} onChange={e => { setOrderBy(e.target.value); if (isRecommended) setHighlight('none'); }}>
                {orders.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
              </select>
            </div>
            <div style={s.fg}><label style={s.lbl}>📡 STATUS</label>
              <select style={s.sel} value={tiktokStatus} onChange={e => { setTiktokStatus(e.target.value); if (isRecommended) setHighlight('none'); }}>
                <option value="ALL">All</option>
                <option value="ACTIVE">Active</option>
                <option value="INACTIVE">Inactive</option>
              </select>
            </div>
            <div style={s.fg}><label style={s.lbl}>🎯 RECOMMENDED</label>
              <HighlightPicker value={highlight} onChange={setHighlight} />
            </div>
          </div>
        )}
        {tab === 'tiktok' && isRecommended && highlightExpanded && (
          <p style={s.fallbackNote}>ℹ️ Not enough top-performing ads this week. Showing the best from the last 30 days.</p>
        )}

        {/* META FILTERS */}
        {tab === 'meta' && (
          <div className="filterBar" style={s.filterBar}>
            <div style={s.fg}><label style={s.lbl}>🌍 COUNTRY</label>
              <select style={s.sel} value={metaCountry} onChange={e => { setMetaCountry(e.target.value); if (isRecommended) setHighlight('none'); }}>
                {metaCountries.map(c => <option key={c} value={c}>{c === 'ALL' ? 'All Countries' : c}</option>)}
              </select>
            </div>
            <div style={s.fg}><label style={s.lbl}>📅 PERIOD</label>
              <select style={s.sel} value={metaPeriod} onChange={e => { setMetaPeriod(e.target.value); if (isRecommended) setHighlight('none'); }}>
                {periods.map(p => <option key={p.v} value={p.v}>{p.l}</option>)}
              </select>
            </div>
            <div style={s.fg}><label style={s.lbl}>📊 SORT BY</label>
              <select style={s.sel} value={metaSortBy} onChange={e => { setMetaSortBy(e.target.value); if (isRecommended) setHighlight('none'); }}>
                {ordersMeta.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
              </select>
            </div>
            <div style={s.fg}><label style={s.lbl}>📡 STATUS</label>
              <select style={s.sel} value={metaStatus} onChange={e => { setMetaStatus(e.target.value); if (isRecommended) setHighlight('none'); }}>
                <option value="ACTIVE">Active</option>
                <option value="ALL">All</option>
                <option value="INACTIVE">Inactive</option>
              </select>
            </div>
            <div style={s.fg}><label style={s.lbl}>🎯 RECOMMENDED</label>
              <HighlightPicker value={highlight} onChange={setHighlight} />
            </div>
          </div>
        )}
        {tab === 'meta' && isRecommended && highlightExpanded && (
          <p style={s.fallbackNote}>ℹ️ Not enough top-performing ads this week. Showing the best from the last 30 days.</p>
        )}

        {/* CONTENT */}
        {loading ? (
          <div style={s.center}>
            <div style={s.spin}/><p style={{ color: '#8888aa', marginTop: '1rem' }}>Loading...</p>
          </div>
        ) : ads.length === 0 ? (
          <div style={s.center}>
            <p style={{ fontSize: '2.5rem' }}>📭</p>
            <p style={{ color: '#8888aa' }}>Nothing found</p>
            <button style={s.retryBtn} onClick={fetchAds}>Try again</button>
          </div>
        ) : (
          <>
            <div style={s.grid}>
              {/* ✅ Dedup by library_id for meta, id for tiktok */}
              {[...new Map(ads.map((ad,i) => [ad._raw?.library_id || ad.id || i, ad])).values()]
                .map((ad,i) => <AdCard key={ad._raw?.library_id || ad.id || i} ad={ad} platform={tab} initialSaved={savedIds.has(ad._raw?.library_id || ad.id)} />)
              }
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  page:    { padding: '80px clamp(1rem,4vw,2rem) 3rem' },
  hero:    { marginBottom: '1.75rem' },
  h1:      { fontSize: 'clamp(1.4rem,4vw,2rem)', fontWeight: 900, letterSpacing: '-.02em' },
  sub:     { color: '#8888aa', marginTop: '.4rem', fontSize: '.9rem' },

  tabRow:  { display: 'flex', gap: '.5rem', marginBottom: '1.25rem', flexWrap: 'wrap' },
  tab: {
    display: 'flex', alignItems: 'center', gap: '7px',
    padding: '.55rem 1.2rem',
    borderRadius: '10px',
    border: '1.5px solid rgba(255,255,255,.07)',
    background: 'transparent',
    color: '#555',
    fontSize: '.85rem', fontWeight: 700, cursor: 'pointer',
    transition: 'all .18s',
  },

  filterBar: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '1rem', alignItems: 'end', padding: '1.25rem', background: '#0f0f1a', borderRadius: '12px', border: '1px solid rgba(255,255,255,.07)', marginBottom: '.5rem' },
  fg:      { display: 'flex', flexDirection: 'column', gap: '.4rem', width: '100%', minWidth: 0 },
  lbl:     { fontSize: '.72rem', color: '#8888aa', fontWeight: 700, letterSpacing: '.05em' },
  sel:     { width: '100%', boxSizing: 'border-box', height: '38px', padding: '.5rem .9rem', background: '#161625', border: '1px solid rgba(255,255,255,.08)', borderRadius: '8px', color: '#f0f0f8', fontSize: '.85rem', cursor: 'pointer', outline: 'none' },
  fallbackNote: { color: '#8b6bff', fontSize: '.8rem', margin: '.6rem 0 1rem', fontWeight: 600 },
  newTag:  { fontSize: '.55rem', fontWeight: 800, color: '#fff', background: 'linear-gradient(135deg,#6c47ff,#8b6bff)', padding: '.1rem .4rem', borderRadius: '5px', marginLeft: '.35rem', verticalAlign: 'middle' },
  searchBtn: { padding: '.5rem 1.1rem', background: 'linear-gradient(135deg,#6c47ff,#8b6bff)', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 700, cursor: 'pointer', fontSize: '.85rem', whiteSpace: 'nowrap' },
  retryBtn:  { padding: '.55rem 1.2rem', background: 'linear-gradient(135deg,#6c47ff,#8b6bff)', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 700, cursor: 'pointer', fontSize: '.85rem', marginTop: '.5rem' },

  count: { color: '#8888aa', fontSize: '.83rem', marginBottom: '1rem' },
  grid:  { display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(min(280px,100%),1fr))', gap: '1.25rem' },
  center:{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '300px', gap: '.5rem' },
  spin:        { width: '40px', height: '40px', border: '3px solid rgba(108,71,255,.2)', borderTop: '3px solid #6c47ff', borderRadius: '50%', animation: 'spin 1s linear infinite' },
  noCreditBanner: { display: 'flex', alignItems: 'center', gap: '1rem', padding: '.85rem 1.25rem', background: 'rgba(255,79,135,.06)', border: '1px solid rgba(255,79,135,.2)', borderRadius: '10px', marginBottom: '1rem', color: '#ff4f87', fontSize: '.85rem', fontWeight: 600 },
  upgradeLink: { marginLeft: 'auto', padding: '.35rem .9rem', background: 'linear-gradient(135deg,#6c47ff,#8b6bff)', color: '#fff', borderRadius: '7px', textDecoration: 'none', fontSize: '.8rem', fontWeight: 700 },
};
